// extracted by mini-css-extract-plugin
export default {"item":"person_item__L8-lE","avatar":"person_avatar__k9bIe","name":"person_name__Mfiqc","login":"person_login__TdYXD","info":"person_info__U3Gzf","btns":"person_btns__nAxib"};